import React from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const generatePages = () => {
    const pages = [];

    // If totalPages is small, show all pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show the first page
      pages.push(1);

      // Show ellipsis if currentPage is beyond 3
      if (currentPage > 3) {
        pages.push("...");
      }

      // Show current, previous, and next pages
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Show ellipsis if currentPage is before totalPages - 2
      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      // Always show the last page
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="flex gap-2 justify-center mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 mr-3 bg-gray-200 rounded disabled:opacity-50"
      >
        <MdKeyboardArrowLeft />
      </button>

      {generatePages().map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && onPageChange(page)}
          className={`h-9 w-9 rounded-full font-semibold text-xs ${
            currentPage === page
              ? "bg-[#FFDB1B] text-white"
              : "bg-gray-100 text-black"
          } ${page === "..." ? "cursor-default" : ""}`}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 ml-3 bg-gray-200 rounded disabled:opacity-50"
      >
        <MdKeyboardArrowRight />
      </button>
    </div>
  );
};

export default Pagination;


